import React, { useEffect, useState } from "react";
import blogFetch from "../../axios/config";
import { getIdCompany } from "../../utils/constantes";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import TextField from "@mui/material/TextField";
import { IManufacturer } from "./manufacturerInferfaces";
const { forwardRef, useImperativeHandle } = React;

export default forwardRef((props: any, ref) => {
  const [selectedValue, setSelectedValue] = useState<IManufacturer>({
    mfC_PK_idManufacturer: 0,
    mfC_name: "",
    mfC_fantasyName: "",
    mfC_cnpj: "",
    mfC_phone: "",
    mfC_adress: "",
    mfC_active: true,
    mfC_FK_companyId: getIdCompany(),
  });
  const [isLoading, setIsLoading] = useState<boolean>(false);

  useEffect(() => {
    getmanufacturer();
  }, []);
  useImperativeHandle(ref, () => ({
    addManufacturer,
    updateManufacturer,
  }));

  const addManufacturer = async () => {
    try {
      const response = await blogFetch.post("/manufacturer", selectedValue);
      return response.status;
    } catch (error) {
      console.error(error);
      return null;
    }
  };

  const updateManufacturer = async () => {
    try {
      const response = await blogFetch.put(
        "/manufacturer/" + props.idManufacturer,
        selectedValue
      );

      return response.status;
    } catch (error) {
      console.error(error);
      return null;
    }
  };

  const getmanufacturer = async () => {
    if (props.idManufacturer != null) {
      setIsLoading(true);
      try {
        setIsLoading(true);
        let response = await blogFetch.get(
          `/manufacturer/${props.idManufacturer}`
        );
        let data = response.data;
        setTimeout(() => {
          setSelectedValue(data);
          setIsLoading(false);
        }, 300);
        return data;
      } catch (error) {
        console.error(error);
        setIsLoading(false);
      }
    }
  };

  return (
    <>
      {isLoading ? (
        <div className="loading-container">
          <center>
            <FontAwesomeIcon icon={faSpinner} spin />
          </center>
        </div>
      ) : (
        <div>
          <div className="mb-3">
            <TextField
              id="outlined-basic"
              label="Razão Social"
              variant="outlined"
              fullWidth
              value={selectedValue.mfC_name}
              onChange={(e) =>
                setSelectedValue({ ...selectedValue, mfC_name: e.target.value })
              }
            />
          </div>
          <div className="mb-3">
            <TextField
              id="outlined-basic"
              label="Nome Fantasia"
              variant="outlined"
              fullWidth
              value={selectedValue.mfC_fantasyName}
              onChange={(e) =>
                setSelectedValue({
                  ...selectedValue,
                  mfC_fantasyName: e.target.value,
                })
              }
            />
          </div>
          <div className="mb-3">
            <TextField
              id="outlined-basic"
              label="CNPJ"
              variant="outlined"
              fullWidth
              value={selectedValue.mfC_cnpj}
              onChange={(e) =>
                setSelectedValue({ ...selectedValue, mfC_cnpj: e.target.value })
              }
            />
          </div>
          <div className="mb-3">
            <TextField
              id="outlined-basic"
              label="Telefone"
              variant="outlined"
              fullWidth
              value={selectedValue.mfC_phone}
              onChange={(e) =>
                setSelectedValue({
                  ...selectedValue,
                  mfC_phone: e.target.value,
                })
              }
            />
          </div>
          <div className="mb-3">
            <TextField
              id="outlined-basic"
              label="Endereço"
              variant="outlined"
              fullWidth
              value={selectedValue.mfC_adress}
              onChange={(e) =>
                setSelectedValue({
                  ...selectedValue,
                  mfC_adress: e.target.value,
                })
              }
            />
          </div>
        </div>
      )}
    </>
  );
});
